<template>
  <div class="tile">
    <div class="icon">
      <ColorTile :color="color" />
    </div>
    <div class="tile-description">
      <div class="tile-headline">{{ name }}</div>
      <div class="tile-effect">{{ effect }}</div>
    </div>
    <div class="actions">
      <EditIcon title="editieren" class="edit" @click="selectForEdit" />
    </div>
  </div>
</template>

<script>
import EditIcon from "vue-material-design-icons/Pencil";
import { mapActions } from "vuex";
import ColorTile from "./ColorTile";

export default {
  name: "ConfigTile",
  components: {
    EditIcon,
    ColorTile
  },
  props: {
    name: { type: String, default: "" },
    effect: { type: String, default: "" },
    index: { type: Number, default: 0 },
    color: { type: String, default: "" }
  },
  methods: {
    ...mapActions("configurations", [
      "selectConfigForEdit",
      "deleteSelectedConfig"
    ]),
    async selectForEdit() {
      this.$emit("select", this.index);
    }
  }
};
</script>

<style scoped>
.tile {
  background-color: white;
  color: black;
  display: flex;
  flex-direction: row;
  /*height: 80px;*/
  width: 390px;
  position: relative;
  margin-left: 20px;
  margin-top: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  -webkit-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.5);
}

.tile-description {
  text-align: left;
}

.tile-headline {
  color: #0178b7;
  font-size: 1.2rem;
  font-weight: bold;
  padding-left: 10px;
  padding-top: 10px;
}

.tile-effect {
  font-weight: bold;
  color: rgba(0, 0, 0, 0.4);
  padding-left: 10px;
  padding-top: 5px;
}

.icon {
  min-width: 80px;
  height: auto;
  /*margin-bottom: 1px;*/
  overflow-y: hidden;
}

.icon img {
  height: 100%;
  width: 100%;
}

.actions {
  display: flex;
  margin-left: auto;
  padding-right: 10px;
  border-left: 1px solid rgba(0, 0, 0, 0.8);
  align-items: center;
  justify-content: center;
  color: rgba(0, 0, 0, 0.4);
}

.edit {
  align-self: center;
  padding-left: 10px;
}

.edit:hover {
  cursor: pointer;
  color: #00a7ff;
}

@media (max-width: 575px) {
  .tile {
    margin-right: 10px;
    margin-left: 10px;
    width: calc(100% - 20px);
  }
}
</style>
